/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type VehicleDevice,
    VehicleDeviceFromJSON,
    VehicleDeviceToJSON,
} from '../models/VehicleDevice';
import {
    type VehicleDeviceCreate,
    VehicleDeviceCreateFromJSON,
    VehicleDeviceCreateToJSON,
} from '../models/VehicleDeviceCreate';
import {
    type VehicleDeviceSortKey,
    VehicleDeviceSortKeyFromJSON,
    VehicleDeviceSortKeyToJSON,
} from '../models/VehicleDeviceSortKey';
import {
    type VehicleDeviceStatus,
    VehicleDeviceStatusFromJSON,
    VehicleDeviceStatusToJSON,
} from '../models/VehicleDeviceStatus';
import {
    type VehicleDeviceUpdate,
    VehicleDeviceUpdateFromJSON,
    VehicleDeviceUpdateToJSON,
} from '../models/VehicleDeviceUpdate';
import {
    type VehicleDeviceVersionUpdate,
    VehicleDeviceVersionUpdateFromJSON,
    VehicleDeviceVersionUpdateToJSON,
} from '../models/VehicleDeviceVersionUpdate';

export interface VehicleDevicesCreateVehicleDeviceRequest {
    vehicleDeviceCreate: VehicleDeviceCreate;
}

export interface VehicleDevicesDeleteVehicleDeviceRequest {
    vehicleDeviceId: string;
}

export interface VehicleDevicesListVehicleDevicesRequest {
    pageSize: number;
    search?: string | null;
    status?: VehicleDeviceStatus;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleDeviceSortKey;
}

export interface VehicleDevicesListVehicleDevicesMetadataRequest {
    pageSize: number;
    search?: string | null;
    status?: VehicleDeviceStatus;
}

export interface VehicleDevicesReadVehicleDeviceRequest {
    vehicleDeviceId: string;
}

export interface VehicleDevicesReadVehicleDeviceByHardwareKeyRequest {
    hardwareKey: string;
}

export interface VehicleDevicesReadVehicleDeviceByVehicleRequest {
    vehicleId: string;
}

export interface VehicleDevicesUpdateVehicleDeviceRequest {
    vehicleDeviceId: string;
    vehicleDeviceUpdate: VehicleDeviceUpdate;
}

export interface VehicleDevicesUpdateVehicleDeviceVersionRequest {
    vehicleDeviceVersionUpdate: VehicleDeviceVersionUpdate;
}

export interface VehicleDevicesValidateCreateVehicleDeviceRequest {
    vehicleDeviceCreate: VehicleDeviceCreate;
}

export interface VehicleDevicesValidateUpdateVehicleDeviceRequest {
    vehicleDeviceId: string;
    vehicleDeviceUpdate: VehicleDeviceUpdate;
}

/**
 * VehicleDevicesApi - interface
 * 
 * @export
 * @interface VehicleDevicesApiInterface
 */
export interface VehicleDevicesApiInterface {
    /**
     * Creates request options for vehicleDevicesCreateVehicleDevice without sending the request
     * @param {VehicleDeviceCreate} vehicleDeviceCreate 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesCreateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesCreateVehicleDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new vehicle device.
     * @summary Create a vehicle device
     * @param {VehicleDeviceCreate} vehicleDeviceCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesCreateVehicleDeviceRaw(requestParameters: VehicleDevicesCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>>;

    /**
     * Create a new vehicle device.
     * Create a vehicle device
     */
    vehicleDevicesCreateVehicleDevice(requestParameters: VehicleDevicesCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice>;

    /**
     * Creates request options for vehicleDevicesDeleteVehicleDevice without sending the request
     * @param {string} vehicleDeviceId 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesDeleteVehicleDeviceRequestOpts(requestParameters: VehicleDevicesDeleteVehicleDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the vehicle device with the given ID.
     * @summary Delete a vehicle device
     * @param {string} vehicleDeviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesDeleteVehicleDeviceRaw(requestParameters: VehicleDevicesDeleteVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the vehicle device with the given ID.
     * Delete a vehicle device
     */
    vehicleDevicesDeleteVehicleDevice(requestParameters: VehicleDevicesDeleteVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleDevicesListVehicleDevices without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {VehicleDeviceStatus} [status] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleDeviceSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesListVehicleDevicesRequestOpts(requestParameters: VehicleDevicesListVehicleDevicesRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the vehicle devices present. If `search` is specified, return values similar to the `serial_number` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List vehicle devices
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {VehicleDeviceStatus} [status] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleDeviceSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesListVehicleDevicesRaw(requestParameters: VehicleDevicesListVehicleDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleDevice>>>;

    /**
     * Lists all the vehicle devices present. If `search` is specified, return values similar to the `serial_number` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List vehicle devices
     */
    vehicleDevicesListVehicleDevices(requestParameters: VehicleDevicesListVehicleDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleDevice>>;

    /**
     * Creates request options for vehicleDevicesListVehicleDevicesMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {VehicleDeviceStatus} [status] 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesListVehicleDevicesMetadataRequestOpts(requestParameters: VehicleDevicesListVehicleDevicesMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Vehicle device listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {VehicleDeviceStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesListVehicleDevicesMetadataRaw(requestParameters: VehicleDevicesListVehicleDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle device listing metadata
     */
    vehicleDevicesListVehicleDevicesMetadata(requestParameters: VehicleDevicesListVehicleDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for vehicleDevicesReadVehicleDevice without sending the request
     * @param {string} vehicleDeviceId 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesReadVehicleDeviceRequestOpts(requestParameters: VehicleDevicesReadVehicleDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the vehicle device specified by the given ID.
     * @summary Get a single vehicle device
     * @param {string} vehicleDeviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesReadVehicleDeviceRaw(requestParameters: VehicleDevicesReadVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>>;

    /**
     * Returns the vehicle device specified by the given ID.
     * Get a single vehicle device
     */
    vehicleDevicesReadVehicleDevice(requestParameters: VehicleDevicesReadVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice>;

    /**
     * Creates request options for vehicleDevicesReadVehicleDeviceByHardwareKey without sending the request
     * @param {string} hardwareKey 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesReadVehicleDeviceByHardwareKeyRequestOpts(requestParameters: VehicleDevicesReadVehicleDeviceByHardwareKeyRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the vehicle device specified by the given hardware key.
     * @summary Get a single vehicle device by its hardware key
     * @param {string} hardwareKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesReadVehicleDeviceByHardwareKeyRaw(requestParameters: VehicleDevicesReadVehicleDeviceByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>>;

    /**
     * Returns the vehicle device specified by the given hardware key.
     * Get a single vehicle device by its hardware key
     */
    vehicleDevicesReadVehicleDeviceByHardwareKey(requestParameters: VehicleDevicesReadVehicleDeviceByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice>;

    /**
     * Creates request options for vehicleDevicesReadVehicleDeviceByVehicle without sending the request
     * @param {string} vehicleId 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesReadVehicleDeviceByVehicleRequestOpts(requestParameters: VehicleDevicesReadVehicleDeviceByVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the vehicle device specified by the given Vehicle ID.
     * @summary Get a single vehicle device by its assigned vehicle
     * @param {string} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesReadVehicleDeviceByVehicleRaw(requestParameters: VehicleDevicesReadVehicleDeviceByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>>;

    /**
     * Returns the vehicle device specified by the given Vehicle ID.
     * Get a single vehicle device by its assigned vehicle
     */
    vehicleDevicesReadVehicleDeviceByVehicle(requestParameters: VehicleDevicesReadVehicleDeviceByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice>;

    /**
     * Creates request options for vehicleDevicesUpdateVehicleDevice without sending the request
     * @param {string} vehicleDeviceId 
     * @param {VehicleDeviceUpdate} vehicleDeviceUpdate 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesUpdateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesUpdateVehicleDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the vehicle device specified by the given ID.
     * @summary Update vehicle device
     * @param {string} vehicleDeviceId 
     * @param {VehicleDeviceUpdate} vehicleDeviceUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesUpdateVehicleDeviceRaw(requestParameters: VehicleDevicesUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>>;

    /**
     * Update the vehicle device specified by the given ID.
     * Update vehicle device
     */
    vehicleDevicesUpdateVehicleDevice(requestParameters: VehicleDevicesUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice>;

    /**
     * Creates request options for vehicleDevicesUpdateVehicleDeviceVersion without sending the request
     * @param {VehicleDeviceVersionUpdate} vehicleDeviceVersionUpdate 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesUpdateVehicleDeviceVersionRequestOpts(requestParameters: VehicleDevicesUpdateVehicleDeviceVersionRequest): Promise<runtime.RequestOpts>;

    /**
     * Update only versioning related vehicle device data based on the elobox associated with the vehicle token used for logging in.  This solution is also pretty clear, as the vehicle device is otherwise not allowed to edit any information about itself, making this a very sturdy solution.
     * @summary Allow a vehicle to update its own vehicle device.
     * @param {VehicleDeviceVersionUpdate} vehicleDeviceVersionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesUpdateVehicleDeviceVersionRaw(requestParameters: VehicleDevicesUpdateVehicleDeviceVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>>;

    /**
     * Update only versioning related vehicle device data based on the elobox associated with the vehicle token used for logging in.  This solution is also pretty clear, as the vehicle device is otherwise not allowed to edit any information about itself, making this a very sturdy solution.
     * Allow a vehicle to update its own vehicle device.
     */
    vehicleDevicesUpdateVehicleDeviceVersion(requestParameters: VehicleDevicesUpdateVehicleDeviceVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice>;

    /**
     * Creates request options for vehicleDevicesValidateCreateVehicleDevice without sending the request
     * @param {VehicleDeviceCreate} vehicleDeviceCreate 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesValidateCreateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesValidateCreateVehicleDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new vehicle device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a vehicle device
     * @param {VehicleDeviceCreate} vehicleDeviceCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesValidateCreateVehicleDeviceRaw(requestParameters: VehicleDevicesValidateCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new vehicle device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle device
     */
    vehicleDevicesValidateCreateVehicleDevice(requestParameters: VehicleDevicesValidateCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehicleDevicesValidateUpdateVehicleDevice without sending the request
     * @param {string} vehicleDeviceId 
     * @param {VehicleDeviceUpdate} vehicleDeviceUpdate 
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesValidateUpdateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesValidateUpdateVehicleDeviceRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given vehicle device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate vehicle device update
     * @param {string} vehicleDeviceId 
     * @param {VehicleDeviceUpdate} vehicleDeviceUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleDevicesApiInterface
     */
    vehicleDevicesValidateUpdateVehicleDeviceRaw(requestParameters: VehicleDevicesValidateUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given vehicle device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle device update
     */
    vehicleDevicesValidateUpdateVehicleDevice(requestParameters: VehicleDevicesValidateUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class VehicleDevicesApi extends runtime.BaseAPI implements VehicleDevicesApiInterface {

    /**
     * Creates request options for vehicleDevicesCreateVehicleDevice without sending the request
     */
    async vehicleDevicesCreateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesCreateVehicleDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceCreate',
                'Required parameter "vehicleDeviceCreate" was null or undefined when calling vehicleDevicesCreateVehicleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleDeviceCreateToJSON(requestParameters['vehicleDeviceCreate']),
        };
    }

    /**
     * Create a new vehicle device.
     * Create a vehicle device
     */
    async vehicleDevicesCreateVehicleDeviceRaw(requestParameters: VehicleDevicesCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>> {
        const requestOptions = await this.vehicleDevicesCreateVehicleDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleDeviceFromJSON(jsonValue));
    }

    /**
     * Create a new vehicle device.
     * Create a vehicle device
     */
    async vehicleDevicesCreateVehicleDevice(requestParameters: VehicleDevicesCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice> {
        const response = await this.vehicleDevicesCreateVehicleDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesDeleteVehicleDevice without sending the request
     */
    async vehicleDevicesDeleteVehicleDeviceRequestOpts(requestParameters: VehicleDevicesDeleteVehicleDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceId'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceId',
                'Required parameter "vehicleDeviceId" was null or undefined when calling vehicleDevicesDeleteVehicleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/{vehicle_device_id}`;
        urlPath = urlPath.replace('{vehicle_device_id}', encodeURIComponent(String(requestParameters['vehicleDeviceId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the vehicle device with the given ID.
     * Delete a vehicle device
     */
    async vehicleDevicesDeleteVehicleDeviceRaw(requestParameters: VehicleDevicesDeleteVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleDevicesDeleteVehicleDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the vehicle device with the given ID.
     * Delete a vehicle device
     */
    async vehicleDevicesDeleteVehicleDevice(requestParameters: VehicleDevicesDeleteVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleDevicesDeleteVehicleDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleDevicesListVehicleDevices without sending the request
     */
    async vehicleDevicesListVehicleDevicesRequestOpts(requestParameters: VehicleDevicesListVehicleDevicesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleDevicesListVehicleDevices().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the vehicle devices present. If `search` is specified, return values similar to the `serial_number` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List vehicle devices
     */
    async vehicleDevicesListVehicleDevicesRaw(requestParameters: VehicleDevicesListVehicleDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VehicleDevice>>> {
        const requestOptions = await this.vehicleDevicesListVehicleDevicesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleDeviceFromJSON));
    }

    /**
     * Lists all the vehicle devices present. If `search` is specified, return values similar to the `serial_number` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List vehicle devices
     */
    async vehicleDevicesListVehicleDevices(requestParameters: VehicleDevicesListVehicleDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VehicleDevice>> {
        const response = await this.vehicleDevicesListVehicleDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesListVehicleDevicesMetadata without sending the request
     */
    async vehicleDevicesListVehicleDevicesMetadataRequestOpts(requestParameters: VehicleDevicesListVehicleDevicesMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehicleDevicesListVehicleDevicesMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle device listing metadata
     */
    async vehicleDevicesListVehicleDevicesMetadataRaw(requestParameters: VehicleDevicesListVehicleDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.vehicleDevicesListVehicleDevicesMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle device listing metadata
     */
    async vehicleDevicesListVehicleDevicesMetadata(requestParameters: VehicleDevicesListVehicleDevicesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.vehicleDevicesListVehicleDevicesMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesReadVehicleDevice without sending the request
     */
    async vehicleDevicesReadVehicleDeviceRequestOpts(requestParameters: VehicleDevicesReadVehicleDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceId'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceId',
                'Required parameter "vehicleDeviceId" was null or undefined when calling vehicleDevicesReadVehicleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/{vehicle_device_id}`;
        urlPath = urlPath.replace('{vehicle_device_id}', encodeURIComponent(String(requestParameters['vehicleDeviceId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the vehicle device specified by the given ID.
     * Get a single vehicle device
     */
    async vehicleDevicesReadVehicleDeviceRaw(requestParameters: VehicleDevicesReadVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>> {
        const requestOptions = await this.vehicleDevicesReadVehicleDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleDeviceFromJSON(jsonValue));
    }

    /**
     * Returns the vehicle device specified by the given ID.
     * Get a single vehicle device
     */
    async vehicleDevicesReadVehicleDevice(requestParameters: VehicleDevicesReadVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice> {
        const response = await this.vehicleDevicesReadVehicleDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesReadVehicleDeviceByHardwareKey without sending the request
     */
    async vehicleDevicesReadVehicleDeviceByHardwareKeyRequestOpts(requestParameters: VehicleDevicesReadVehicleDeviceByHardwareKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['hardwareKey'] == null) {
            throw new runtime.RequiredError(
                'hardwareKey',
                'Required parameter "hardwareKey" was null or undefined when calling vehicleDevicesReadVehicleDeviceByHardwareKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/by/hardware_key/{hardware_key}`;
        urlPath = urlPath.replace('{hardware_key}', encodeURIComponent(String(requestParameters['hardwareKey'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the vehicle device specified by the given hardware key.
     * Get a single vehicle device by its hardware key
     */
    async vehicleDevicesReadVehicleDeviceByHardwareKeyRaw(requestParameters: VehicleDevicesReadVehicleDeviceByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>> {
        const requestOptions = await this.vehicleDevicesReadVehicleDeviceByHardwareKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleDeviceFromJSON(jsonValue));
    }

    /**
     * Returns the vehicle device specified by the given hardware key.
     * Get a single vehicle device by its hardware key
     */
    async vehicleDevicesReadVehicleDeviceByHardwareKey(requestParameters: VehicleDevicesReadVehicleDeviceByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice> {
        const response = await this.vehicleDevicesReadVehicleDeviceByHardwareKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesReadVehicleDeviceByVehicle without sending the request
     */
    async vehicleDevicesReadVehicleDeviceByVehicleRequestOpts(requestParameters: VehicleDevicesReadVehicleDeviceByVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleId'] == null) {
            throw new runtime.RequiredError(
                'vehicleId',
                'Required parameter "vehicleId" was null or undefined when calling vehicleDevicesReadVehicleDeviceByVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/by/vehicle/{vehicle_id}`;
        urlPath = urlPath.replace('{vehicle_id}', encodeURIComponent(String(requestParameters['vehicleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the vehicle device specified by the given Vehicle ID.
     * Get a single vehicle device by its assigned vehicle
     */
    async vehicleDevicesReadVehicleDeviceByVehicleRaw(requestParameters: VehicleDevicesReadVehicleDeviceByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>> {
        const requestOptions = await this.vehicleDevicesReadVehicleDeviceByVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleDeviceFromJSON(jsonValue));
    }

    /**
     * Returns the vehicle device specified by the given Vehicle ID.
     * Get a single vehicle device by its assigned vehicle
     */
    async vehicleDevicesReadVehicleDeviceByVehicle(requestParameters: VehicleDevicesReadVehicleDeviceByVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice> {
        const response = await this.vehicleDevicesReadVehicleDeviceByVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesUpdateVehicleDevice without sending the request
     */
    async vehicleDevicesUpdateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesUpdateVehicleDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceId'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceId',
                'Required parameter "vehicleDeviceId" was null or undefined when calling vehicleDevicesUpdateVehicleDevice().'
            );
        }

        if (requestParameters['vehicleDeviceUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceUpdate',
                'Required parameter "vehicleDeviceUpdate" was null or undefined when calling vehicleDevicesUpdateVehicleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/{vehicle_device_id}`;
        urlPath = urlPath.replace('{vehicle_device_id}', encodeURIComponent(String(requestParameters['vehicleDeviceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleDeviceUpdateToJSON(requestParameters['vehicleDeviceUpdate']),
        };
    }

    /**
     * Update the vehicle device specified by the given ID.
     * Update vehicle device
     */
    async vehicleDevicesUpdateVehicleDeviceRaw(requestParameters: VehicleDevicesUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>> {
        const requestOptions = await this.vehicleDevicesUpdateVehicleDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleDeviceFromJSON(jsonValue));
    }

    /**
     * Update the vehicle device specified by the given ID.
     * Update vehicle device
     */
    async vehicleDevicesUpdateVehicleDevice(requestParameters: VehicleDevicesUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice> {
        const response = await this.vehicleDevicesUpdateVehicleDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesUpdateVehicleDeviceVersion without sending the request
     */
    async vehicleDevicesUpdateVehicleDeviceVersionRequestOpts(requestParameters: VehicleDevicesUpdateVehicleDeviceVersionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceVersionUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceVersionUpdate',
                'Required parameter "vehicleDeviceVersionUpdate" was null or undefined when calling vehicleDevicesUpdateVehicleDeviceVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleDeviceVersionUpdateToJSON(requestParameters['vehicleDeviceVersionUpdate']),
        };
    }

    /**
     * Update only versioning related vehicle device data based on the elobox associated with the vehicle token used for logging in.  This solution is also pretty clear, as the vehicle device is otherwise not allowed to edit any information about itself, making this a very sturdy solution.
     * Allow a vehicle to update its own vehicle device.
     */
    async vehicleDevicesUpdateVehicleDeviceVersionRaw(requestParameters: VehicleDevicesUpdateVehicleDeviceVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleDevice>> {
        const requestOptions = await this.vehicleDevicesUpdateVehicleDeviceVersionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleDeviceFromJSON(jsonValue));
    }

    /**
     * Update only versioning related vehicle device data based on the elobox associated with the vehicle token used for logging in.  This solution is also pretty clear, as the vehicle device is otherwise not allowed to edit any information about itself, making this a very sturdy solution.
     * Allow a vehicle to update its own vehicle device.
     */
    async vehicleDevicesUpdateVehicleDeviceVersion(requestParameters: VehicleDevicesUpdateVehicleDeviceVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleDevice> {
        const response = await this.vehicleDevicesUpdateVehicleDeviceVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehicleDevicesValidateCreateVehicleDevice without sending the request
     */
    async vehicleDevicesValidateCreateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesValidateCreateVehicleDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceCreate',
                'Required parameter "vehicleDeviceCreate" was null or undefined when calling vehicleDevicesValidateCreateVehicleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleDeviceCreateToJSON(requestParameters['vehicleDeviceCreate']),
        };
    }

    /**
     * Validate data for a new vehicle device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle device
     */
    async vehicleDevicesValidateCreateVehicleDeviceRaw(requestParameters: VehicleDevicesValidateCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleDevicesValidateCreateVehicleDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new vehicle device without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle device
     */
    async vehicleDevicesValidateCreateVehicleDevice(requestParameters: VehicleDevicesValidateCreateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleDevicesValidateCreateVehicleDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehicleDevicesValidateUpdateVehicleDevice without sending the request
     */
    async vehicleDevicesValidateUpdateVehicleDeviceRequestOpts(requestParameters: VehicleDevicesValidateUpdateVehicleDeviceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleDeviceId'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceId',
                'Required parameter "vehicleDeviceId" was null or undefined when calling vehicleDevicesValidateUpdateVehicleDevice().'
            );
        }

        if (requestParameters['vehicleDeviceUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleDeviceUpdate',
                'Required parameter "vehicleDeviceUpdate" was null or undefined when calling vehicleDevicesValidateUpdateVehicleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicle_devices/{vehicle_device_id}/validate`;
        urlPath = urlPath.replace('{vehicle_device_id}', encodeURIComponent(String(requestParameters['vehicleDeviceId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleDeviceUpdateToJSON(requestParameters['vehicleDeviceUpdate']),
        };
    }

    /**
     * Validate data for updating the given vehicle device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle device update
     */
    async vehicleDevicesValidateUpdateVehicleDeviceRaw(requestParameters: VehicleDevicesValidateUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehicleDevicesValidateUpdateVehicleDeviceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given vehicle device, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle device update
     */
    async vehicleDevicesValidateUpdateVehicleDevice(requestParameters: VehicleDevicesValidateUpdateVehicleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehicleDevicesValidateUpdateVehicleDeviceRaw(requestParameters, initOverrides);
    }

}
